/**
 * Portal Routes Configuration
 * Routes are now centralized in config/CentralizedRoutes.js
 * This file imports routes from centralized configuration
 */
import { CENTRALIZED_ROUTE_MAP } from '../config/CentralizedRoutes';
import PortalNotFound from '../pages/portal/PortalNotFound';
import { Navigate } from 'react-router-dom';

/**
 * Convert centralized route map to React Router route format for portal
 */
export const portalRoutes = [
  ...Object.entries(CENTRALIZED_ROUTE_MAP)
    .filter(([routePath]) => routePath.startsWith('/portal'))
    .map(([routePath, Component]) => {
      // Remove '/portal' prefix for React Router nested routes, preserving dynamic segments
      let path = routePath.replace('/portal', '') || 'dashboard';
      // Ensure dynamic routes like :id are preserved
      if (path.startsWith('/')) {
        path = path.substring(1);
      }
      
      // Handle redirects for unified pages with tabs
      if (routePath.includes('/knowledge/') && routePath !== '/portal/knowledge' && routePath !== '/portal/knowledgebase') {
        const tab = routePath.split('/').pop();
        return {
          path,
          element: () => <Navigate to={`/portal/knowledgebase?tab=${tab}`} replace />
        };
      }
      if (routePath.includes('/profile/') && routePath !== '/portal/profile') {
        const tab = routePath.split('/').pop();
        return {
          path,
          element: () => <Navigate to={`/portal/profile?tab=${tab}`} replace />
        };
      }
      if (routePath.includes('/feedback/') && routePath !== '/portal/feedback') {
        const tab = routePath.split('/').pop();
        return {
          path,
          element: () => <Navigate to={`/portal/feedback?tab=${tab}`} replace />
        };
      }
      if (routePath === '/portal/tickets/my-tickets') {
        return {
          path,
          element: () => <Navigate to="/portal/tickets" replace />
        };
      }
      if (routePath === '/portal/tickets/new') {
        return {
          path,
          element: () => <Navigate to="/portal/tickets/create" replace />
        };
      }
      // /portal/tickets/create should render CreateTicketForm directly, not redirect
      if (routePath === '/portal/home' || routePath === '/portal/index') {
        return {
          path,
          element: () => <Navigate to="/portal/dashboard" replace />
        };
      }
      
      return {
        path,
        element: Component
      };
    }),
  // Catch-all for portal
  { path: '*', element: PortalNotFound }
];

export default portalRoutes;
